import gql from "graphql-tag";

export const referralFormData = gql`
  query referralFormData($id: ID!) {
    referral(id: $id) {
      id
      name
      phone
      email
      region {
        id
        name
      }
      stationPlanned
      stationInstalled
      user {
        id
        firstName
        lastName
      }
      comment
      status
      transactions {
        id
        type
        amount
        createdAt
        comment
        user {
          id
          firstName
          lastName
        }
      }
      accrued
      createdAt
      bx24DealUrl
      briefUrl
      buildingArea
      roofType
      typeOfRoofCovering
      consumptionPerMonthInSummer
      consumptionPerMonthInWinter
      presenceOfBattery
      numberOfPhasesUnderContract
      numberOfPhasesActual
      connectionType
      typeOfSolarPanelPlacement
    }

    regions {
      id
      name
    }

    referralOptions {
      options
    }
  }
`;
export const agentData = gql`
  query agentDataData($userId: ID!) {
    agent(userId: $userId) {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
`;
